module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter One")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/line.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "chapterTitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("THE PARK AVENUE MIND-SET")])]), _vm._v(" "), _c('div', {
    staticClass: "chapterEpigraph"
  }, [_c('p', {
    staticClass: "chapterEpigraphText1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("You can never be too rich or too thin")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "chapterEpigraphSource1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("—"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("WALLIS SIMPSON, DUCHESS OF WINDSOR")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }, [_c('p', {
    staticClass: "paraCenter1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/dot.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Upper East Side")]), _vm._v(" of Manhattan is one of the most exciting and dynamic places in the world. It is also one of the areas of highest concentrated wealth in the world. The people who live in the elegant apartments and town houses in our neighborhood have a lifestyle defined by long working hours, hectic schedules, and the pressure of always looking their best. They are under constant time constraint juggling work, deadlines, meetings and social obligations, domestic and international travel, plus personal commitments. Time is a very precious commodity in New York City, and not something to be wasted. Park Avenue people are constantly in a hurry to get to the next appointment, to conquer the next rung on the social ladder, and to achieve another professional success. They work hard, they play hard, and they demand the best of everything.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }, [_vm._v("Men and women who have arrived at the pinnacle of success want to look and feel fabulous once they get there! Their occupations and social circles require that they “look the part.” They strive not only to be chic; they want to be fashionably slim. But the excessive hours of working, ")]), _c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_vm._v("high-profile entertaining, and abundance of the best foods also contribute to an expanding waistline. They don’t plan for the midafternoon hunger by tossing a piece of fruit or a container of yogurt into their briefcase or Hermès bag, so by dinnertime they arrive at a restaurant famished and dive right into the bread basket; they postpone an exercise session until the end of the day instead of scheduling it for the first thing in the morning (a time when the session cannot be interrupted or forgotten); they cut their schedules too tight so that taxis are taken for distances that could easily be walked. In effect, it is an accumulation of time misspent that makes their weight gradually creep up.")])]), _c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For my patients to enjoy what they have worked so hard for, they must change their behavior and realize the truism that life and health are gifts. The magnificent mind and body that provided them with the good life can become old before its time if not treated with respect. By approaching eating and exercise with the same discipline that characterizes the rest of their lives, their excess weight is lost, and a vibrant, youthful appearance is regained.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadB2",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("What Is the Park Avenue Mind-Set?")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("People who can afford to live on Park Avenue (or in other upscale areas) exhibit certain recognizable character traits. Because residence in this prime area is so valued, these traits are also associated with financial success. They tend to be highly competitive, always in a hurry, impatient, status conscious, and they want to be noticed. They are often preoccupied with work. These traits are true for both males and females.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Women who are not working outside of the home and are married to successful men with the Park Avenue mind-set are often just as driven. These women often belong to charitable groups and raise millions of dollars for worthy causes they are passionate about. In fact, many organizations would not be able to exist without the tireless work of these dedicated women. However, there is an expectation that they have to look perfect at all times. There is an intense competitiveness to looking fabulous at this level.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_vm._v("Since the 1960s reign of such New York socialite icons as Slim ")]), _c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_vm._v("Keith, Doris Duke, and Babe Paley, dubbed the “beautiful people” by Diana Vreeland, the beloved editor of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Harper’s Bazaar")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Vogue")]), _vm._v(", the rich have been considered the great influencers of fashion, style, and culture. As Wallis Simpson, the American-born Duchess of Windsor, once said, “You can never be too rich or too thin.” The Park Avenue princess lives, dresses, and dies by this motto. And she may unknowingly sacrifice her health to do so. While it may be true that you cannot really be too rich, you most definitely can be too thin. By maintaining a dangerously low weight to fit into sleek designer fashions, a woman may eliminate vital nutrition. The items that I find lacking most commonly in such people are dairy products and sufficient protein. In some cases, such extreme dieters are fighting a neverending battle with a body type they were born with, instead of eating sensibly to sustain the health of the body they have.")])]), _c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_c('p', {
    staticClass: "chapterHeadB2",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("How Your Body Type Affects Weight Gain")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Your body type is determined largely by genetics, over which we have no control. William Sheldon, M.D., first developed the concept that everyone is born with a certain body type. Dr. Sheldon outlined three basic body types: ectomorph, mesomorph, and endomorph.")]), _vm._v(" "), _c('ul', {
    staticClass: "bulletList"
  }, [_c('li', {
    staticClass: "listItem"
  }, [_vm._v("Ectomorph is the type that fashion magazines would have us aspire to: tall with long, thin limbs and little body fat. Most supermodels and basketball players are the ectomorph body type. It is an unrealistic goal for many people not born this type.")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("Mesomorph body types are characterized by an athletic, strong, and compact body. The world’s top figure skaters and tennis players tend to fall into the mesomorph category.")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("Endomorphs are round and gain weight easily.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The body type that you were born with is the body type that you will have for life. It is one of your physical characteristics, just like your eye color. If your goal is to keep yourself in the best of health, by avoiding excess weight, exercising daily, and maintaining correct posture you will look fabulous "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("whatever")]), _vm._v(" body type you possess.")])]), _c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_c('p', {
    staticClass: "paraCenter2",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/22.gif"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadB2",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Do You Need a Medicine Cabinet Makeover?")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I have heard some pretty amazing stories from patients about the lengths they have gone to in order to lose weight: fad diets, smoking, laxatives, and even stimulants like amphetamines and cocaine. Losing weight by any of these methods can result in a disruption of the body’s chemistry. While people may lose weight by such means, their health declines and they end up looking worse and worse.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Unscrupulous medical professionals, especially via the Internet, give ready access to a variety of dubious medications promising weight loss. Many of my patients have previously tried unsuccessfully to become thinner by taking such “miracle” pills and potions only to find that the drugs were sabotaging their health. Thyroid stimulants, diuretics, nervous system stimulants, and the like can take a strong mind and body and turn it into a medical emergency: Unnecessary thyroid medication will cause bone loss and arrhythmias. Diuretics are dehydrating and put a strain on the heart. Stimulants cause an increase in both blood pressure and heart rate. Yet I have seen many patients who, out of desperation, have resorted to these means.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Don’t become lured by an unhealthy solution to excess weight. There is no place in your life for this!")])]), _vm._v(" "), _c('hr')])]), _c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('p', {
    staticClass: "chapterHeadB2",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Drugs That Cause Weight Gain")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A number of prescription and over-the-counter medications are associated with significant weight gain. Unfortunately, patients are not always told in advance about this unwelcome side effect: A weight gain occurs and the patient doesn’t know why.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("These medications are frequent causes of weight gain:")]), _vm._v(" "), _c('ul', {
    staticClass: "bulletList"
  }, [_c('li', {
    staticClass: "listItem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Antidepressants:")]), _vm._v(" Fluoxetine (Prozac), sertraline (Zoloft), and paroxetine (Paxil) are effective antidepressants but can increase weight. A different class of antidepressant also associated with weight gain is mirtazapine (Remeron). For someone who is depressed, these drugs can lift the heavy emotional load; however, they should only be prescribed by a competent psychiatrist—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("never")]), _vm._v(" purchase them on the Internet. Antidepressants that do "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not")]), _vm._v(" increase weight are bupropion (Wellbutrin) and nefazodone (Serzone).")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Antipsychotics")])]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Antiseizure medications:")]), _vm._v(" Just about all of these medications cause some weight gain with the exception of topiramate (Topamax), which may cause weight loss.")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Oral contraceptives")]), _vm._v(" (Yasmin may cause weight loss)")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Corticosteroids")]), _vm._v(" (for asthma, autoimmune conditions, and allergies)")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Antihistamines")]), _vm._v(" (for allergies)")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Beta blockers")]), _vm._v(" (for high blood pressure)")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("If you are taking any of the above drugs and have gained weight, do not assume that your doctor knows that you are experiencing weight gain, because it does not occur in all patients. Discuss your weight change with your physician. There are alternative medications that may work just as well for you. For example, decongestants may be substituted for antihistamines; ACE inhibitors or calcium channel blockers may be substituted for beta blockers; antidepressants that do not cause weight gain as a side effect can be substituted for those that promote weight gain; barrier methods can replace oral contraceptives.")])]), _c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Julia is a thirty-eight-year-old mother of twins who experienced a depression after the end of her ten-year marriage. She consulted a psychiatrist, and was treated with psychotherapy and a high dosage of paroxetine (Paxil). After several months, her depression resolved and she stopped seeing her psychiatrist. But four years and thirty pounds later, this young woman was still taking the medication plus an oral contraceptive and an antihistamine. Distressed because her own weight-loss efforts were not working, she sought my help to lose weight.")]), _vm._v(" "), _c('p', {
    staticClass: "boxText",
    staticStyle: {
      "text-indent": "5%",
      "margin-left": "5%"
    }
  }, [_vm._v("When I spoke with Julia, she was amazed to hear of the combined effects of her medications, as their potential for weight gain had never been explained to her. First, I suggested that she consult with her psychiatrist, whom she had not seen in over three years, to assess whether she could safely eliminate the antidepressant; she had been obtaining paroxetine (Paxil) prescriptions from her primary care physician. Her psychiatrist agreed that she did not need the medicine anymore. She was able to reduce her antihistamine, which she took for hay fever, to a minimal amount on high-pollen days. Julia lost the excess thirty pounds in about three months. She is now happy, confident, and slimmer.")]), _vm._v(" "), _c('p', {
    staticClass: "boxText",
    staticStyle: {
      "text-indent": "5%",
      "margin-left": "5%"
    }
  }, [_vm._v("The drugs were probably appropriate at the time they were prescribed, but she should have been told that weight gain was a possibility. Also, her use of medications had continued for longer than necessary. Additionally, mixing medications had had a cumulative effect with regard to weight gain.")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadB2",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Myths of Diet Drugs")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_vm._v("Baby boomers are known to demand the “instant gratification” factor. This is a real problem with weight management because there are no shortcuts. A magic pill that will cut appetite, raise metabolism, and give you a supermodel body does not exist. There are medications that treat obesity, but they only work when combined with diet and exercise. One of the worst things that a physician can do is to prescribe any of these ")]), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_vm._v("medications without explaining the limitations of the drug, and not stressing that they won’t work without changing the diet. And, like every medicine, they all have side effects.")])]), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('p', {
    staticClass: "chapterHeadB2",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Drugs That Reduce Food Intake")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The drugs listed are prescription medications and should only be taken under a doctor’s supervision. The Internet has made these medications available online, which has resulted in serious medical consequences, including death. If you have a significant amount of weight to lose, consult with your doctor about a diet and exercise plan.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Phentermine, which decreases appetite, is the most widely prescribed and oldest prescription weight-loss medication, having been around for thirty years. It stimulates the release of norepinephrine and dopamine from nerve terminals. As such, it increases the heart rate and raises blood pressure. Other side effects are dry mouth, constipation, and insomnia. Because of its effect on blood pressure and the heart rate, usage of phentermine should be carefully monitored, and the suggested treatment period is no longer than six weeks.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Several years ago, the combination of phentermine and fenfluramine (Phen Fen) was thought to be the answer for quick and easy weight loss. People who took the drug experienced dramatic reduction in weight and felt almost no hunger. But soon this “miracle drug” was found to be responsible for damage to the heart valves. Tragically, several deaths resulted from the drug and it has now been removed from the market. The gold standard of weight loss has always been a healthy diet and exercise. Don’t risk your life by using this dangerous drug combination.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_vm._v("Sibutramine (Meridia) is a norepinephrine and serotonin reuptake inhibitor. Weight loss is dose dependent: It affects the appetite center of the brain, where it increases satiety so you feel full faster and with a smaller quantity of food. The drug has been extremely well studied. Clinical studies have shown that sibutramine is effective and safe, if properly prescribed. Blood pressure and heart rate must be monitored, however, as sibutramine can cause a dangerous rise in blood pressure. Sibutramine should never be used in patients with a history of coronary artery disease, congestive heart failure, cardiac arrhythmia, or stroke. Because its action affects the brain, it is not safe to take with most antidepressant ")]), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_vm._v("drugs. The side effects of sibutramine include dry mouth, constipation, and insomnia.")])]), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Orlistat (Xenical) is unique in that it does not enter the circulation but rather works in the digestive system to block the absorption of fat, which is then eliminated from the body through the stool. If you eat too much fat, diarrhea is the unhappy result. Orlistat works well because its action is entirely within the digestive tract; it doesn’t interact with other medications, and does not raise blood pressure or the heart rate. However, because it blocks absorption of fat, it blocks the absorption of the fat-soluble vitamins, and these should be taken separately.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The truth is that there is no ideal weight-loss pill. Medications are suitable for some people, and can assist in raising the metabolism forward, but they are useless if exercise and an optimal diet are not in place. You won’t need drugs with my plan.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadB2",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Nonprescription Weight-Loss Drugs")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Drugs that are sold over the counter and over the Internet promise weight loss but deliver little in the way of results. Weight-loss supplements fall into two basic categories: those that claim to suppress appetite and those that block the absorption of food. The appetite suppressors contain caffeinelike substances (such as ephedra or ma huang, which is now banned). Studies in animals have indicated a small appetite-suppressant effect, but the human studies have been too brief to support the claims.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Appetite suppressants have the side effects of increasing blood pressure, headache, insomnia, and heart palpitations. You will feel jittery, as is the case with too much coffee. The absorption-blockers seem to have a small effect, but cause side effects of bloating and gastrointestinal complaints.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The bottom line is: Over-the-counter and Internet-sold drugs do not work, and are usually not safe. Save your money. You have to change your diet and exercise routine to see a meaningful change in your weight.")])]), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTitle",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("THE PARK AVENUE MYSTIQUE")])]), _vm._v(" "), _c('p', {
    staticClass: "boxTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("According to the New York City Department of Parks and Recreation, what is now Park Avenue was originally laid out in the 1811 Commissioners’ Plan as Fourth Avenue. In 1832, the long, narrow strip down the middle of the island was granted to the New York and Harlem Railroad, which ran horse-drawn cars along its path, starting with a run between Union Square and Twenty-third Street. By 1834, the service operated from Prince Street to the Upper East Side. Though given its present name in 1888, it was the 1903 conversion from steam to electric train power and the 1913 completion of the present Grand Central Terminal that paved the way for Park Avenue’s future. The previously open rail yards and tracks north of the terminal were covered over between 1921 and 1924, and the avenue’s wide, landscaped center medians gave credibility to its name. Subsequently, the wide malls were narrowed to their present configuration, to accommodate wider traffic lanes.")]), _vm._v(" "), _c('p', {
    staticClass: "boxText",
    staticStyle: {
      "text-indent": "5%",
      "margin-left": "5%"
    }
  }, [_vm._v("Today Park Avenue consists of rows of apartment buildings on the east and west sides of the street, separated in the center of the avenue by wide, planted islands. As the seasons change, so do the lovely gardens. In summer, the plantings consist of begonias; spring, tulips and flowering apple blossoms; fall, chrysanthemums; and the end of the year brings festive and beautifully lighted Christmas trees. The apartment buildings lining Park Avenue embody conservative elegance. Some of the grandest residences were constructed between 1920 and 1930 by Rosario Candela, with only one apartment per floor. Candela’s apartments created the “off the foyer” layout, in which the foyer was an additional room that set the tone for the entry into the formal living space. Candela’s well-constructed apartments had thick walls, large rooms with elegant double moldings, and very high ceilings. Born in Palermo, Italy, Rosario Candela’s father was a plasterer. The architect Candela’s own story represents fulfillment of the American dream, because today his elegant buildings are landmark structures and epitomize New York City living at the highest level. Our office is located in one of the beautiful buildings built by Rosario Candela.")]), _vm._v(" "), _c('hr')])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "boxTitle1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("DO YOU HAVE THE PARK AVENUE MIND-SET?")])]), _vm._v(" "), _c('ol', {
    staticClass: "ol-arabic"
  }, [_c('li', {
    staticClass: "listItem"
  }, [_vm._v("Do you have a sense of time urgency? Are you always in a rush?")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("Do you inhale your food—are you always the first one at the table to finish a meal?")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("Do you talk so fast that people tell you to slow down?")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("Will you sacrifice a health-promoting behavior, such as a yoga class, for an extra hour at the office or to take on one more afterschool activity for your children?")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("Do you reach for a cookie or candy bar to power yourself through the afternoon?")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("Do you speed up at the yellow light?")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("Would you rather spend time working than working out?")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("Do you find yourself falling into bed at night and saying, “Not tonight, dear,” because you have no energy left for sex?")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("Do you talk on your cell phone or eat meals while driving?")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("Do you eat on the run; i.e., in the car, at the airport?")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("Do you frequently order in or order room service?")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("Do you hit the mini bar the minute you check into your hotel room?")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("Are your thumbs sore from using your Blackberry all day long?")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("Are you a multitasker?")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("Are you addicted to caffeine?")])]), _vm._v(" "), _c('p', {
    staticClass: "boxText",
    staticStyle: {
      "text-indent": "5%",
      "margin-left": "5%"
    }
  }, [_vm._v("If you answered yes to two or more of these questions, you "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("need")]), _vm._v(" my plan. And the more affirmative answers you gave, then the more likely the plan will be successful for you, because of your drive. The positive aspects of these traits focus you on your work; the negative aspects cause you to neglect your health.")]), _vm._v(" "), _c('p', {
    staticClass: "boxText",
    staticStyle: {
      "text-indent": "5%",
      "margin-left": "5%"
    }
  }, [_vm._v("Since knowledge is power, I suggest that you use this behavior pattern to improve your health and to identify what you are doing wrong. Your strong determination can actually be an asset in correcting the negative health patterns. When these people see that something is broken, they fix it!")]), _vm._v(" "), _c('hr')])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "chapterHeadB1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("How the Park Avenue Mind-Set Could Work for You")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sandra is a forty-five-year-old single woman who is a senior portfolio manager at an investment bank. Since becoming a senior executive, Sandra had allowed her weight to gradually creep upward, due to long hours at the office, little or no time for exercise, and eating out frequently, choosing rich foods. Sandra camouflaged her extra weight with expensive couture suits. While her overall health was good, her total cholesterol was just over 250 mg/dl. Her waistline had increased to 37 inches. Both of these are independent risk factors for disease. Sandra was accustomed to being “in charge” and informed me that she “knew all about eating and how to lose weight,” but clearly she needed help with this. Sandra’s work required her to entertain clients for dinner five nights of the week. Her business dinners were usually at four-star restaurants and always included fine wines. Sandra had an active social life that also included alcohol. If an average drink accounts for 200 kcal—then Sandra was consuming about 4,000 kcal per week just in the form of alcohol! One pound is equivalent to 3,500 kcal—so theoretically just by eliminating alcohol it would be possible for her to lose approximately one pound per week.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("These are the changes I suggested for Sandra:")]), _vm._v(" "), _c('ol', {
    staticClass: "ol-arabic"
  }, [_c('li', {
    staticClass: "listItem"
  }, [_vm._v("Eliminate alcohol. Drink only mineral water at business dinners. Initially, like all of my patients, she resisted this idea but, once she agreed to it, she was amazed at how easy it was. She ordered a large bottle of San Pellegrino and lime slices for the table. Her clients did not seem to mind her abstinence, and she also became more efficient at these meetings.")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("Stay away from the bread basket and order a crudités platter to be served prior to dinner. Sandra saved calories by eliminating simple carbohydrates and was a big hit with her clients. They loved the elegantly presented, chilled vegetables and thought this was a gracious gesture by their hostess. (After all, they were trying to control their weight, too!)")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("Order two appetizers as your dinner or cut the main course in half. Restaurant portions are just too big.")]), _vm._v(" "), _c('li', {
    staticClass: "listItem"
  }, [_vm._v("Make daily aerobic exercise a priority. No more excuses!")])])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Because Sandra enjoyed being in control and saw the program was working for her, she focused her energy on this. After six months, Sandra had lost 35 pounds and normalized her cholesterol. She realized that simply being in a fancy restaurant is not a green light for passively overeating but rather another opportunity to control a situation. I was able to make her Park Avenue mind-set work to her advantage!")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Jackie is one of my favorite success stories, and her story was actually published in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Modern Bride")]), _vm._v(" because it was so inspiring to other women. Exactly one year before she was due to wed her high school sweetheart, Jackie resolved to lose 25 pounds. At five foot six, the bride-to-be was concerned about the weight she had put on in her twenties, a decade she spent drinking and partying. She needed a jumpstart to get her going. When I first inquired about her eating habits, Jackie told me that she only had coffee in the morning. As I probed the nature of this beverage, I learned that she was starting her day with a Starbucks Caffè Mocha Grande with whipped cream. We looked this up and she was astounded to find that the calorie content was a whopping 660 calories! Jackie switched to Skim Cappuccino Grande. As she waited in line at the local Starbucks, she warned her fellow caffeine lovers about the calorie content of her former favorite “coffee” beverage. I put Jackie on a regimen of running, weight training, and a healthier diet. She restructured her eating habits by reading nutritional labels; eating half portions when dining out; and substituting fruits, vegetables, proteins, and whole grains for sweets and fast foods. She cut down on her alcohol intake by switching to occasional low-calorie wine spritzers. As a result, the newly trim bride had her wedding dress taken in from a size 10 to a 6, and marched down the aisle like a diva!")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  })]), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("Here is another typical patient of mine—John, a fifty-six-year-old attorney who heads a law firm representing the music industry. His demanding schedule calls for almost weekly trips to the West Coast. His long workdays and extensive travel resulted in his becoming 75 pounds overweight—and exhausted. When he finally saw his internist, John was diagnosed with high cholesterol, high blood pressure, and type ")]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("2 diabetes mellitus. John’s lifestyle had made him wealthy in a material sense but had bankrupted his health! Luckily, his internist referred John to me. John, a highly motivated individual, was resolved to change his life for the better. He readily implemented the diet and exercise recommendations that I made. Travel was a particular concern. Although John always flew first class, he realized that the food served by the airline was not what he should eat while trying to lose weight. He followed my suggestion and took an 8-ounce container of plain low-fat yogurt, cut-up vegetables, and low-fat string cheese with him on flights. He drank only water while on board the plane. While in Los Angeles, he always stayed at the Peninsula in Beverly Hills. He asked his hotel to pack a lunch of smoked salmon and vegetables for the return flight. John made a point of walking two miles daily on his home treadmill and on business trips. As his weight came down, John was able to jog comfortably.")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Over time, as his cholesterol, blood pressure, and diabetes resolved, I was able to reduce and subsequently discontinue all of John’s medications. He made his health a priority and did not come up with excuses to avoid living a health-promoting lifestyle. He simply followed the Klauer Plan one day at a time. While continuing to manage the responsibilities and pressures of a demanding career, he chose to also reverse the illness within his body. He changed his life. He was still under the same time pressure but now made time for his health.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("I tell Sandra’s, Jackie’s, and John’s stories because: (a) If they were able to make these changes, then so can you; and (b) by committing to my diet and exercise plan, you can improve your health. When you consider each change that these very different people made, you realize that these are things that anyone can do. Their strong will and determination to persist are what enabled these people to change their lives. They did not give up and they did not give in! Day after day, they followed the plan that they saw was working until they reached their targets.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("The key is to keep your goal in sight. It is your health and well-being that are at stake, and these are high stakes, indeed. Treat a weight-loss plan like a business plan—have a goal and take the neces")]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("sary steps to get there. As another successful patient stated, you must “plan the work and work the plan!” It will not happen overnight but if you persist, you will get there. The wonderful news is that when you follow this plan you can expect to look and feel better than you have in years.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  })]), _c('a', {
    attrs: {
      "id": "page14"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page14"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e34e240","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780312340391_ch01.vue
// module id = 84
// module chunks = 0